module.exports = __webpack_public_path__ + "static/merch1Front-131773eb17d58d96b0a86d3c66a990fb.png";